export default "__VITE_ASSET__BC9Yd5$G__"